import { Classroom } from '@/api/classroom'

const state = () => ({
    hots: [],
    hot: null,

    LoadingHot: false,
    isSuccessHot: true,
    messageHot: '',
})

const getters = {
    hotList: state => state.hots,
    hot: state => state.hot,
    isLoadingHot: state => state.isLoadingHot,
    isSuccessHot: state => state.isSuccessHot,
    messageHot: state => state.messageHot,

}

const actions = {
    async fetchAllHots({ commit }) {

        commit('setHotIsLoading', true)

        await Classroom.getListHot()
            .then(response => {
                // console.log(response.data)
                commit('setHots', response.data.data)
                commit('setHotIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setHotIsLoading', false)
            })
    },
    async fetchDetailHot({ commit }, id) {
        commit('setHotIsLoading', true)
        await Classroom.hotDetail(id)
            .then(response => {
                // console.log(response)
                commit('setHotDetail', response.data.data)
                commit('setHotIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setHotIsLoading', false)
            })
    },
    async addHot({ commit }, hot) {

        await Classroom.hotAdd(hot)
            .then(res => {
                // console.log('dari vuex', res.data)
                if (res.data.success) {

                    commit('setSuccessHot', true)
                    commit('setMessageHot', 'Berhasil Menambahkan Hot')
                } else {
                    commit('setSuccessHot', false)
                    commit('setMessageHot', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessHot', false)
                commit('setMessageHot', error.errors[0].message)
            })
    },
    async deleteHot({ commit }, hot) {

        await Classroom.hotDelete(hot)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessHot', true)
                    commit('setMessageHot', 'Berhasil Menghapus Hot')
                } else {
                    commit('setSuccessHot', false)
                    commit('setMessageHot', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessHot', true)
                commit('setMessageHot', error.errors[0].message)
            })
    }
}

const mutations = {
    setHots: (state, hots) => {
        state.hots = hots
    },

    setHotDetail: (state, hot) => {
        state.hot = hot
    },

    setHotIsLoading: (state, isLoadingHot) => {
        state.isLoadingHot = isLoadingHot
    },

    setSuccessHot: (state, isSuccessHot) => {
        state.isSuccessHot = isSuccessHot
    },

    setMessageHot: (state, messageHot) => {
        state.messageHot = messageHot
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}